import React from 'react'
import ListCreatedVirtualClassrooms from '../common'

const ListAllPage = () => <ListCreatedVirtualClassrooms type="all" />

export default ListAllPage
